module.exports = __webpack_public_path__ + "static/media/edit-pencil-pen-svgrepo-com.32c871ba.svg";